import { motion } from "framer-motion";
import { GraduationCap, Trophy } from "lucide-react";
import { UNIVERSITIES } from "@/data/content";

export default function Universities() {
  return (
    <section id="universities" data-testid="universities-section" className="section">
      <div className="container-x">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 rounded-full border border-[#B31942]/20 bg-[#B31942]/5 px-3 py-1 text-[12px] font-semibold text-[#B31942]">
            Popular Universities
          </div>
          <h2 className="mt-4 font-display font-extrabold text-4xl md:text-5xl tracking-tight text-slate-900">
            Placements at the world's most <span className="text-[#0A3161]">respected campuses</span>.
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
          {UNIVERSITIES.map((u, i) => (
            <motion.div
              key={u.name}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: (i % 5) * 0.05 }}
              className="group rounded-2xl bg-white border border-black/5 p-5 hover:-translate-y-1 transition-transform soft-shadow hover:soft-shadow-lg"
              data-testid={`university-${u.name.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <div className="flex items-center justify-between">
                <span className="text-3xl">{u.flag}</span>
                <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-[#B31942] bg-[#B31942]/10 px-2 py-0.5 rounded-full">
                  <Trophy className="h-3 w-3" /> {u.rank}
                </span>
              </div>
              <h3 className="mt-4 font-display text-[17px] font-bold text-slate-900 leading-snug">{u.name}</h3>
              <div className="mt-2 text-xs text-slate-500 inline-flex items-center gap-1.5">
                <GraduationCap className="h-3.5 w-3.5" /> {u.country}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
